import { render, staticRenderFns } from "./SessionContent.vue?vue&type=template&id=843c9b08&scoped=true&"
import script from "./SessionContent.vue?vue&type=script&lang=js&"
export * from "./SessionContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "843c9b08",
  null
  
)

export default component.exports